import { useNavigate, useSearchParams, createSearchParams } from "react-router-dom";

const useSetParamToURL = () => {
	const navigate = useNavigate();

	const [searchParams, setSearchParams] = useSearchParams();

	const setPathWithParams = (pathname, paramsData = null) => {
		const removeKeys = ["token"];
		const nextParams = new URLSearchParams(searchParams.toString());

		removeKeys.forEach((key) => nextParams.delete(key));

		if (paramsData && paramsData.length > 0) {
			paramsData.forEach(({ key, value }) => {
				nextParams.set(key, value);
			});
		}

		const queryParams = createSearchParams(nextParams);
		const target = `${pathname}?${queryParams}`;
		const replace = pathname.includes("hospital") || pathname === "/";
		navigate(target, { replace });
	}

	const setPreviousParams = (pathname) => {
		const allowedParams = Array.from(searchParams.entries()).filter(
			([key]) => !["tab", "provider", "redirectAfter", "token", "message"].includes(key)
		);

		const filteredParams = createSearchParams(allowedParams);
		return `${pathname}?${filteredParams}`;
	}

	const setParamToURL = (paramsData) => {
		if (!paramsData || paramsData.length === 0) return;

		const nextParams = new URLSearchParams(searchParams.toString());
		paramsData.forEach(({ key, value }) => {
			nextParams.set(key, value);
		});
		setSearchParams(nextParams, { replace: true });
	}

	const getAccountId = () => {
		return searchParams.get("accountId");
	}

	const removeParamFromURL = (keysToRemove = []) => {
		if (!Array.isArray(keysToRemove) || keysToRemove.length === 0) return;

		const newParams = new URLSearchParams(searchParams.toString());
		let changed = false;

		keysToRemove.forEach((key) => {
			if (newParams.has(key)) {
				newParams.delete(key);
				changed = true;
			}
		});

		if (changed) {
			setSearchParams(newParams, { replace: true });
		}
	};

	return {
		getAccountId,
		setPreviousParams,
		setParamToURL,
		setPathWithParams,
		removeParamFromURL
	};
};

export default useSetParamToURL;
